import { j as i } from "../../_virtual/jsx-runtime.js";
import { c as a } from "../../_virtual/compiler-runtime.js";
import { cn as m } from "../../utils/cn.js";
const n = (r) => {
  const e = a.c(9);
  let l, c;
  e[0] !== r ? ({
    className: l,
    ...c
  } = r, e[0] = r, e[1] = l, e[2] = c) : (l = e[1], c = e[2]);
  let o;
  e[3] !== l ? (o = m("inline-block", l), e[3] = l, e[4] = o) : o = e[4];
  let s;
  e[5] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ i.jsx("path", { d: "M8 1.25C4.287 1.25 1.25 4.287 1.25 8S4.288 14.75 8 14.75c3.713 0 6.75-3.037 6.75-6.75S11.713 1.25 8 1.25zM6.038 12.862a5.242 5.242 0 0 1-3.257-4.553h1.32c.302 0 .548.245.548.548v1.392c0 .145.057.284.16.387l1.069 1.069c.103.103.16.242.16.387v.77zm5.77-1.27A5.223 5.223 0 0 1 8 13.25c-.269 0-.527-.039-.785-.079v-1.426c0-.303.245-.548.548-.548h.133a.548.548 0 0 0 .548-.548V8.86a.548.548 0 0 0-.548-.549h-1.87a.548.548 0 0 1-.549-.548v-.96c0-.275.11-.54.304-.734l1.37-1.37a1.04 1.04 0 0 0 .304-.734V2.805c.182-.019.359-.055.545-.055 1.386 0 2.64.55 3.58 1.43L9.698 6.062a.647.647 0 0 0-.19.458v1.035c0 .172.068.337.19.458l.424.424c.121.122.286.19.458.19h.58c.358 0 .648.29.648.648v2.318z" }), e[5] = s) : s = e[5];
  let t;
  return e[6] !== c || e[7] !== o ? (t = /* @__PURE__ */ i.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: "16", height: "16", fill: "currentColor", role: "img", focusable: "false", className: o, ...c, children: s }), e[6] = c, e[7] = o, e[8] = t) : t = e[8], t;
};
n.displayName = "GlobeIcon";
export {
  n as GlobeIcon
};
